import { render, staticRenderFns } from "./Migracao.vue?vue&type=template&id=32e8d777&"
import script from "./Migracao.vue?vue&type=script&lang=js&"
export * from "./Migracao.vue?vue&type=script&lang=js&"
import style0 from "./Migracao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports